export const Skills = [
  ["HTML", "CSS", "Bootstrap", "JavaScript", "jQuery", "React", "Vue", "Git"],
  [
    "A logical approach to work",
    "Attention to detail",
    "Problem solving",
    "Critical thinking",
    "Decision-making",
    "Adaptability",
    "Creativity",
  ],
  ["Fast Typing (90wpm)", "English"],
];

export const Projects = [
  {
    id: 1,
    name: "Goodies App",
    desc: `Goodies helps users discover and explore food items with three main features: searching for food items, pagination for search results, and detailed item information.`,
    image: "/assets/images/deliciousFood.png",
    responsive: ["Mobile", "Dekstop", "Tablet"],
    technologies: ["React"],
    github: "https://github.com/vladimirmomiroski/delicious_food",
    host: "https://goodies-food.netlify.app",
  },
  {
    id: 2,
    name: "Glam Vista",
    desc: `A blog highlighting jewelry, weddings, dresses, and watches. Developed with Next.js, Express.js, and MySQL for storing posts.`,
    image: "/assets/images/glamVista.png",
    responsive: ["Mobile", "Dekstop", "Tablet"],
    technologies: ["nextJS", "ExpressJS", "MySql"],
    github: "https://github.com/vladimirmomiroski/GlamVista",
    host: "https://www.theglamvista.com",
  },
  {
    id: 3,
    name: "Coin Tracker",
    desc: `CoinTracker is an application for tracking your monthly income as well as tracking your
      monthly expenses with the possibility of setting budget limits.`,
    image: "/assets/images/coinTrackerLogo.png",
    responsive: ["Mobile", "Dekstop", "Tablet"],
    technologies: ["React", "Material-UI"],
    github: "https://github.com/vladimirmomiroski/coinTracker",
    host: "https://coin-tracker15.netlify.app/",
  },
  {
    id: 4,
    name: "Street Artists",
    desc: `Web space for every street artist that will allow them to be able to track their
      income, and to have a place on the web where they can showcase their masterpieces.`,
    image: "/assets/images/streetArtistsLogo.png",
    responsive: ["Mobile"],
    technologies: ["HTML", "CSS", "JavaScript"],
    github: "https://github.com/vladimirmomiroski/streetArtists",
    host: "https://street-artists.netlify.app/",
  },
  {
    id: 5,
    name: "Pintado Portfolio",
    desc: `The Pintado Portfolio is an elegant online showcase of captivating drawings, providing a window into the artist's creative world.`,
    image: "/assets/images/AJ.png",
    responsive: ["Mobile", "Dekstop", "Tablet"],
    technologies: ["React"],
    github: "https://github.com/vladimirmomiroski/pintado-portfolio",
    host: "https://aleksandra-pintado.netlify.app",
  },
  {
    id: 6,
    name: "Bike Shop",
    desc: `Mini bike-app, with a functionality to sort by gender and brand.`,
    image: "/assets/images/bikeLogo.png",
    responsive: ["Dekstop"],
    technologies: ["React"],
    github: "https://github.com/vladimirmomiroski/bike-shop",
    host: "https://mini-bike-shop.netlify.app",
  },
];
